import type { StylableElementProps } from '@subaio/components'

import { getIsoCountryCode } from '../countryCodeMaps'
import { getSquareCountryFlagImageUrl } from './getSquareCountryFlagImageUrl'
import { Image } from './Image'

type Props = StylableElementProps & {
	countryCode: string | null
	size?: number
	defaultImage?: string
	isRounded?: boolean
}

export const CountryFlagSquare = ({
	countryCode,
	size = 28,
	defaultImage,
	isRounded = true,
	className,
	style,
}: Props) => {
	const imageUrl = getSquareCountryFlagImageUrl(getIsoCountryCode(countryCode) ?? '') ?? defaultImage

	return imageUrl ? (
		<Image src={imageUrl} size={size} className={className} style={style} isRounded={isRounded} />
	) : null
}
